<template>
  <el-dialog
    :title="$t('goldWithdrawal.applyWithdrawal')"
    :visible.sync="dialogVisible"
    width="80%"
    @close="resetForm"
  >
    <el-form :model="auditGoldWithdrawalInfo" label-width="120px">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item :label="$t('goldWithdrawal.accountName')">
            <el-input
              v-model="auditGoldWithdrawalInfo.goldName"
              disabled
              :placeholder="$t('goldWithdrawal.pleaseEnterAccountName')"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('goldWithdrawal.bankName')">
            <el-input
              v-model="auditGoldWithdrawalInfo.bankName"
              disabled
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item :label="$t('goldWithdrawal.accountHolder')">
            <el-input
              v-model="auditGoldWithdrawalInfo.bankNumName"
              disabled
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('goldWithdrawal.bankAccount')">
            <el-input
              v-model="auditGoldWithdrawalInfo.bankNum"
              disabled
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item :label="$t('goldWithdrawal.applicant')">
            <el-input
              v-model="auditGoldWithdrawalInfo.applyUserName"
              disabled
              :placeholder="$t('goldWithdrawal.pleaseEnterApplicant')"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('goldWithdrawal.applicantPhone')">
            <el-input
              v-model="auditGoldWithdrawalInfo.applyUserTel"
              disabled
              :placeholder="$t('goldWithdrawal.pleaseEnterApplicantPhone')"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-form-item :label="$t('goldWithdrawal.withdrawalAmount')">
        <el-input
          v-model="auditGoldWithdrawalInfo.applyAmount"
          :placeholder="$t('goldWithdrawal.pleaseEnterWithdrawalAmount')"
        />
      </el-form-item>

      <el-form-item :label="$t('goldWithdrawal.applicationDescription')">
        <el-input
          v-model="auditGoldWithdrawalInfo.remark"
          :placeholder="$t('goldWithdrawal.pleaseEnterApplicationDescription')"
        />
      </el-form-item>

      <el-form-item :label="$t('goldWithdrawal.status')">
        <el-select
          v-model="auditGoldWithdrawalInfo.state"
          style="width:100%"
          :placeholder="$t('goldWithdrawal.pleaseSelectStatus')"
        >
          <el-option
            label="请审核"
            value=""
            disabled
          />
          <el-option
            :label="$t('goldWithdrawal.approvedAndPaid')"
            value="C"
          />
          <el-option
            :label="$t('goldWithdrawal.rejected')"
            value="F"
          />
        </el-select>
      </el-form-item>

      <el-form-item :label="$t('goldWithdrawal.auditDescription')">
        <el-input
          v-model="auditGoldWithdrawalInfo.stateMsg"
          type="textarea"
          :placeholder="$t('goldWithdrawal.pleaseEnterAuditDescription')"
        />
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('goldWithdrawal.cancel') }}</el-button>
      <el-button type="primary" @click="auditGoldWithdrawal">{{ $t('goldWithdrawal.submit') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { auditGoldWithdrawal } from '@/api/admin/goldWithdrawal/goldWithdrawalApi'

export default {
  name: 'AuditGoldWithdrawal',
  data() {
    return {
      dialogVisible: false,
      auditGoldWithdrawalInfo: {
        gwId: '',
        goldId: '',
        goldName: '',
        shopId: '',
        amount: '',
        applyAmount: '',
        applyUserName: '',
        applyUserTel: '',
        remark: '',
        state: '',
        stateMsg: '',
        bankNum: '',
        bankNumName: '',
        bankName: ''
      }
    }
  },
  methods: {
    open(row) {
      this.auditGoldWithdrawalInfo = { ...row }
      this.auditGoldWithdrawalInfo.applyAmount = row.amount
      this.auditGoldWithdrawalInfo.state = ''
      this.auditGoldWithdrawalInfo.stateMsg = ''
      this.dialogVisible = true
    },
    resetForm() {
      this.auditGoldWithdrawalInfo = {
        gwId: '',
        goldId: '',
        goldName: '',
        shopId: '',
        amount: '',
        applyAmount: '',
        applyUserName: '',
        applyUserTel: '',
        remark: '',
        state: '',
        stateMsg: '',
        bankNum: '',
        bankNumName: '',
        bankName: ''
      }
    },
    async auditGoldWithdrawal() {
      try {
        if (!this.validateForm()) {
          return
        }
        await auditGoldWithdrawal(this.auditGoldWithdrawalInfo)
        this.$emit('refresh')
        this.dialogVisible = false
        this.$message.success(this.$t('goldWithdrawal.auditSuccess'))
      } catch (error) {
        console.error('审核失败:', error)
        this.$message.error(error.message || this.$t('goldWithdrawal.auditFailed'))
      }
    },
    validateForm() {
      if (!this.auditGoldWithdrawalInfo.applyAmount) {
        this.$message.warning(this.$t('goldWithdrawal.pleaseEnterWithdrawalAmount'))
        return false
      }
      if (!this.auditGoldWithdrawalInfo.state) {
        this.$message.warning(this.$t('goldWithdrawal.pleaseSelectStatus'))
        return false
      }
      if (!this.auditGoldWithdrawalInfo.stateMsg) {
        this.$message.warning(this.$t('goldWithdrawal.pleaseEnterAuditDescription'))
        return false
      }
      return true
    }
  }
}
</script>